<template>
	<view class="temp-page">
		<view class="container_h">
			<view class="container_head" :style="{height: navHeight + 'px', marginTop: statusbarHeight + 'px'}">
				<view class="container_head_address" @click="go">
					<image src="@/static/icon/ar_back_dark@2x.png" mode="widthFix"></image>
				</view>
				<view class="page-title">提交审核</view>
			</view>
		</view>
		<view class="steps-container" :style="{marginTop: (navHeight + statusbarHeight) + 'px'}">
			<view v-for="(item, index) in steps" :key="index" class="step-item">
				<view class="step-line">
					<view class="line" :class="index!=0?`line-v ${index<=active?'value-select':''}`:''"></view>
					<view class="value" :class="index<=active?'value-select':''">{{ index + 1 }}</view>
					<view class="line" :class="index!=2?`line-v ${index<active?'value-select':''}`:''"></view>
				</view>
				<view class="title" :class="index<=active?'select':''">{{ item.title }}</view>
			</view>
		</view>
		<view class="main-container">
			<view class="tips">正在审核</view>
			<view class="tips-detail">信息已提交，审核将在3个工作日以内完成，请注意查看</view>
		</view>
	</view>
</template>

<script>
	import { mapState } from 'vuex'
	export default {
		data() {
			return {
				active: 2,
				steps: [
					{ title: '基本信息' },
					{ title: '实名认证' },
					{ title: '提交审核' }
				],
			}
		},
		computed: {
			...mapState(['statusbarHeight', 'navHeight'])
		},
		methods: {
			go() {
				uni.navigateBack({
					delta: 3
				});
			}
		}
	}
</script>

<style lang="scss" scoped>
.temp-page {
	background-color: #fff;
	height: 100%;
}
	.container_h {
		width: 100%;
		background-color: #f5f5f5;
		height: auto;
		position: fixed;
		top: 0;
		left: 0;
		z-index: 9;
		display: flex;
		.container_head {
			width: 100%;
			padding: 0 32rpx;
			box-sizing: border-box;
			display: flex;
			align-items: center;
			justify-content: flex-start;
			.container_head_address {
				display: flex;
				align-items: center;
				justify-content: flex-start;
				image {
					width: 16rpx;
					height: 30rpx;
				}
			}
		}
		.page-title {
			flex: 1;
			text-align: center;
		}
	}
	.steps-container {
		display: flex;
		background-color: #FFFFFF;
		padding: 66rpx 0 26rpx;
		.step-item {
			width: 33.33%;
			text-align: center;
			.step-line {
				display: flex;
				.line {
					flex: 1;
				}
				.line-v {
					height: 4px;
					background: #D9D9D9;
					margin: auto 0;
				}
				.value {
					width: 48rpx;
					height: 48rpx;
					background: #D9D9D9;
					border-radius: 50%;
					font-weight: 500;
					color: #FFFFFF;
					line-height: 48rpx;
					font-size: 32rpx;
				}
				.value-select {
					background: #D20A0A;
				}
			}
			.title {
				height: 28rpx;
				font-size: 28rpx;
				font-weight: 500;
				color: #CCCCCC;
				line-height: 28rpx;
				margin-top: 16rpx;
			}
			.select {
				color: #D20A0A;
			}
		}
	}
.main-container {
	text-align: center;
	margin-top: 158rpx;
	font-family: PingFang SC-Medium, PingFang SC;
	.tips {
		height: 40rpx;
		font-size: 40rpx;
		font-weight: 400;
		color: #333333;
		line-height: 40rpx;
	}
	.tips-detail {
		height: 24rpx;
		font-size: 24rpx;
		font-weight: 400;
		color: #999999;
		line-height: 24rpx;
		margin-top: 28rpx;
	}
}
</style>
